import { esES } from '@mui/material/locale'
import type { Theme } from '@mui/material/styles'
import { createTheme } from '@mui/material/styles'

import { themeColors } from './themeColors.ts'
import themeOptions from './themeOptions'

export type ThemeNames = keyof typeof themeColors
export type ThemesMap = Record<ThemeNames, Theme>

/** Verifica nombre de thema */
export const isThemeName = (value: unknown): value is ThemeNames =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(themeColors, value)

/** Creación de Matx thema en funcion de las configuraciones */
const createMatxThemes = (): ThemesMap => {
  const result = {} as ThemesMap

  for (const name of Object.keys(themeColors) as ThemeNames[]) {
    const colorOptions = themeColors[name]

    // La paleta completa de esta variante se procesa desde el primer argumento.
    // MUI combina los componentes y el idioma mediante los argumentos siguientes.
    result[name] = createTheme(
      {
        ...themeOptions,
        palette: colorOptions.palette
          ? { ...themeOptions.palette, ...colorOptions.palette }
          : themeOptions.palette,
      },
      colorOptions,
      esES,
    )
  }

  return result
}

export const themes = createMatxThemes()
